import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const IntroMuroLambrinConcavo = () => {
  return (
    <section className="about-service pb-0">
      <div className="container">
        <div className="row align-items-center mt-n1-9">
          <div className="col-lg-6 mt-1-9">
            <div className="pe-lg-6 pe-xl-15">
              <div className="title-style2 mb-2-2 wow fadeIn" data-wow-delay="200ms">
                <h2 className="h1">Lambrín Cóncavo para Paredes y Techos</h2>
              </div>
              <p className="text-secondary text-uppercase font-weight-800 mb-1-9">
              El panel WPC está diseñado exclusivamente para uso en interiores.
              </p>
              <p className="mb-2-9">
              El panel WPC está diseñado exclusivamente para interiores, combinando funcionalidad y estética. Está compuesto por un 60% de resina de madera y un 40% de PVC, lo que le proporciona resistencia y durabilidad. 
              Además, cuenta con un revestimiento de impresión texturizado que le da una apariencia única y elegante.<br></br>
              Este panel es ideal para decorar paredes y techos, ofreciendo una solución práctica y sofisticada para cualquier espacio interior.
              </p>
              <div className="w-xl-90 w-xxl-90 mb-6">
                <BannerNoInstalacion />
              </div>
            </div>
          </div>
          <div className="col-lg-6 mt-1-9">
            <div>
              <div className="row align-items-center">
                <div className="col-6">
                  <div>
                    <img src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-lambrin-concavo/muro-lambrin-concavo-intro.jpg`} alt="Service 1" className="rounded" />
                  </div>
                </div>
                <div className="col-6">
                  <div>
                    <img src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-lambrin-concavo/panel-wpc-en-arco-intro-izq.jpg`} alt="Service 2" className="mb-sm-4 rounded" />
                    <div className="bg-dark p-1-6 p-md-1-9 d-none d-sm-block rounded">
                      <h5 className="mb-0 text-white">Diseño de vanguardia </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroMuroLambrinConcavo;
